<template>
  <div>
    <v-container>

      <p class="display-1 font-weight-light	text-center pa-4">SHOPPING CART</p>
      <v-row>
        <v-col :cols="12" md="9" sm="12" >
          <v-simple-table v-if="cartItems.length >= 1">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">ITEM</th>
                <th class="text-center">PRICE</th>
                <th class="text-center">QUANTITY</th>
                <th class="text-center">TOTAL</th>
                <th class="text-center"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="cartItem in cartItems" :key="cartItem" style="width=10vw">
                <!-- <CartItemCard :cart-item-detail="cartItem"/> -->

                        <td>
                  <v-list-item
                  key="1"
                  @click="showProductDetail(cartItem)"
                >
                  <v-list-item-avatar>
                    <v-img :src="require('../assets/img/shop/1.jpg')"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title > {{ cartItem.title }}</v-list-item-title>
                    <v-list-item-subtitle>Lorem Ipsum</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item></td>
                <td>Ksh {{ cartItem.price }}</td>
                <td>
                 <CartItemCard :cart-item-detail="cartItem" @item-quantity="updateItemPrice"/>
                </td>
                <td>
                  Ksh {{ cartItem.totalPrice }}
                  </td>

                <td>
                  <v-icon @click="removeItemFromCart(cartItem.title)">mdi-close</v-icon>
                  </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-container class="text-center" v-else>
                {{ addItemsMessage }}
              </v-container>
        </v-col>
        <v-col :cols="12" md="3" sm="12" style="background-color: lightgray">
          <TheOrderSummary/>
        </v-col>
      </v-row>
    </v-container>
    <v-card  class="accent" >
      <v-container>
        <v-row no-gutters>
          <v-col class="col-12 col-md-4 col-sm-12">
            <v-row >
              <v-col class="col-12 col-sm-3 pr-4 hidden-sm-only" align="right">
                <v-icon class="display-2">mdi-truck</v-icon>
              </v-col>
              <v-col class="col-12 col-sm-9 pr-4">
                <h3 class="font-weight-light">FREE SHIPPING & RETURN</h3>
                <p class="font-weight-thin">Free Shipping over Ksh 1000</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-12 col-md-4 col-sm-12">
            <v-row >
              <v-col class="col-12 col-sm-3 pr-4" align="right">
                <v-icon class="display-2">mdi-cash-usd</v-icon>
              </v-col>
              <v-col  class="col-12 col-sm-9 pr-4">
                <h3 class="font-weight-light">MONEY BACK GUARANTEE</h3>
                <p class="font-weight-thin">30 Days Money Back Guarantee</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-12 col-md-4 col-sm-12">
            <v-row>
              <v-col class="col-12 col-sm-3 pr-4" align="right">
                <v-icon class="display-2">mdi-headset</v-icon>
              </v-col>
              <v-col  class="col-12 col-sm-9 pr-4">
                <h3 class="font-weight-light">020-800-456-747</h3>
                <p class="font-weight-thin">24/7 Available Support</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import CartItemCard from '@/components/Cart/CartItemCard'
import TheOrderSummary from '@/components/Cart/TheOrderSummary'
import CartItemPrice from '@/components/Cart/CartItemPrice'
    export default {
        data: () => ({
            rating: 4.5,
            // cartItems: [],
            itemQuantity: 1,
            addItemsMessage: "Add an item to your cart to manage",
            breadcrums: [
                {
                    text: 'Home',
                    disabled: false,
                    href: 'breadcrumbs_home',
                },
                {
                    text: 'Clothing',
                    disabled: false,
                    href: 'breadcrumbs_clothing',
                },
                {
                    text: 'T-Shirts',
                    disabled: true,
                    href: 'breadcrumbs_shirts',
                },
            ],
        }),
        components:{
          CartItemCard,
          TheOrderSummary,
          CartItemPrice
        },
        watch: {
          itemQuantity: function(itemQuantity) {
          console.log("Quantity update",itemQuantity)
          // push the cart item detail and update quantity * price
          // const newPrice = 
          // this.$store.commit("updateTotalPrice", newPrice);
        }
      },
      computed: {
        cartItems(){
          return this.$store.getters.cartItems
          }
      },
      methods:{
        showProductDetail(cartItem){
          console.log('Cart item product detail',cartItem)
        },
        updateItemPrice(newPrice){
          console.log("New price:", newPrice)
        },
        removeItemFromCart(cartItemTitle){
          this.$store.commit('removeItemFromCart', cartItemTitle)
        }
      }
    
    }
</script>




// WEBPACK FOOTER //
// src/Views/Cart.vue